export default "__VITE_ASSET__8509f42e__"